/* ForgeHeavy — mobile sticky Add-to-Cart bar.
   Dawn has no native sticky ATC, so this is a minimal addition. It does NOT touch cart
   or variant logic: the bar's button is a plain submit carrying form="product-form-<id>",
   so clicking it fires the real <product-form> submit handler (AJAX add + drawer).
   All this script does is toggle a class based on whether the real ATC is on screen. */
(function () {
  var bar = document.querySelector('.fh-sticky-atc');
  if (!bar || !('IntersectionObserver' in window)) return;

  var target = document.getElementById(bar.dataset.watch);
  if (!target) return;

  new IntersectionObserver(
    function (entries) {
      // Show the bar only once the real button has scrolled up out of view.
      var e = entries[0];
      var below = e.boundingClientRect.top > 0;
      bar.classList.toggle('is-visible', !e.isIntersecting && !below);
    },
    { rootMargin: '0px 0px -8px 0px' }
  ).observe(target);
})();
